import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-statement-list',
  templateUrl: './statement-list.component.html',
  styleUrls: ['./statement-list.component.css']
})
export class StatementListComponent implements OnInit {

  public menu_item_id = '75';
  public add_auth;
  public edit_auth;
  public del_auth;
  private dp = [];

  displayedColumns = ['cash_receipt_no', 'receipt_date', 'acct_name', 'paid', 'payment_method_name', 'comment',
    'detail', 'print', 'edit', 'del'];
  displayedColumns2 = ['cash_receipt_no', 'receipt_date', 'acct_name', 'paid', 'payment_method_name', 'comment'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': 'cash_receipt', 'from_date': new Date(), 'to_date': new Date(), 'cash_receipt_no': '',
    'title': 'إيصالات التسليم'
  };

  Success_Msg; Error_Msg; Del_Msg;
  From_Date; To_Date; Statement_List;
  Cash; Bank; Visa;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {
    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('Statement_List').subscribe((res: string) => {
      this.Statement_List = res;
    });
    this.model['title'] = this.Statement_List;

    translate.get('Cash').subscribe((res: string) => {
      this.Cash = res;
    });

    translate.get('Bank').subscribe((res: string) => {
      this.Bank = res;
    });

    translate.get('Visa').subscribe((res: string) => {
      this.Visa = res;
    });
  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    this.model['from_date'] = new Date(this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-01");
  }

  print(row = null) {
    if (row == null) {
      let html_data = '';
      let form = (document.getElementById('form1') as HTMLFormElement);

      html_data = '<table cellpadding="8" cellspacing="0">';
      html_data += '<tr><td width="33%"> ' + this.From_Date + ': ' + this.model['from_date'].getFullYear() + "-" +
        (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate() + '</td>';
      html_data += '<td width="33%"> ' + this.To_Date + ': ' + this.model['to_date'].getFullYear() + "-" +
        (this.model['to_date'].getMonth() + 1) + "-" + this.model['to_date'].getDate() + ' </td></tr>';
      html_data += '</table>';

      let table = (document.getElementById('receipt_table2') as HTMLTableElement);
      html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
    }
    else
      window.open(this.applicationConstants.statementPrint + "?receipt_no=" + row.cash_receipt_no, "_blank");
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

  search() {
    let condition = "";

    if (this.model['from_date'] != undefined) {
      let from_date = (this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
        this.model['from_date'].getDate() + ' 00:00:00');
      condition += " AND `receipt_date` >= '" + from_date + "'";
    }

    if (this.model['to_date'] != undefined) {
      let to_date = (this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
        this.model['to_date'].getDate() + ' 23:59:59');
      condition += " AND `receipt_date` <= '" + to_date + "'";
    }

    if (this.model['cash_receipt_no'] != '')
      condition = " AND `cash_receipt_no` LIKE '%" + this.model['cash_receipt_no'] + "%'";

    let query = "SELECT * FROM `cash_receipt` WHERE `status` != '0' AND `receipt_no` = 'RECEIPT'" +
      " AND `cash_receipt`.`branch_id` = '" + this.applicationConstants.user_branch_info.user_branch_id + "'" + condition;
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.dp = data.data['list'];
        this.dp.forEach(element => {
          // element.date = (this.dp[count]['date']).substring(0, 10);
          if (element['payment_method'] == 'cash')
            element['payment_method_name'] = this.Cash;
          else if (element['payment_method'] == 'bank')
            element['payment_method_name'] = this.Bank;
          else if (element['payment_method'] == 'visa')
            element['payment_method_name'] = this.Visa;
        });

        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  delStatement(row) {
    if (confirm(this.Del_Msg)) {
      let values;
      values = [{ 'table_name': 'cash_receipt', 'cash_receipt_no': row.cash_receipt_no }];
      values.push({ 'table_name': 'cash_receipt_acct', 'cash_receipt_no': row.cash_receipt_no });
      values.push({ 'table_name': 'cash_receipt_invoice', 'cash_receipt_no': row.cash_receipt_no });

      let obj = { cmd: 'deleteRec', values: values };
      //console.log(values);
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

}
